import React from 'react'

import dayjs from 'dayjs'
import { Avatar } from 'antd'
import Icon from '@forwardflow/ui/Icons'

interface MessageItemProps {
   item: any
}

export const EmailSentItem: React.FC<MessageItemProps> = ({ item }) => {
   return (
      <div className="flex items-end justify-end gap-x-2">
         <div className="flex flex-col bg-[#594180]  max-w-[450px] rounded-3xl rounded-br-none overflow-hidden">
            <div className="flex items-center justify-between py-4 pl-4 pr-6 gap-x-4">
               <div className="w-8 h-8 rounded-full bg-black/30 flexc shrink-0">
                  <Icon name="Email" className="fill-white" />
               </div>
               <div className="flex flex-col items-end justify-between gap-y-1">
                  <p className="text-[14px] font-medium">{item?.content}</p>
                  <p className="text-[10px] text-white/70">
                     {dayjs(item?.ts).format('h:mm A, D MMM YYYY')}
                  </p>
               </div>
            </div>
         </div>
         <Avatar src={item?.assistant?.avatar} className="w-10 h-10">
            {item?.assistant?.name.slice(0, 1) || 'A'}
         </Avatar>
      </div>
   )
}
